import React, { useState } from 'react';
import {connect} from 'react-redux'
import moment from 'moment';

import * as actions from '../../../store/actions'

import PerfectScrollbar from 'react-perfect-scrollbar';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import AddIcon from '@mui/icons-material/Add';
import IconButton from '@mui/material/IconButton';
import {
  CardContent,
  Table,
  TableBody,
  TableCell,
  TableRow,
  TableHead,
  Button,
  Chip,
  Typography,
  Tooltip
} from '@mui/material';

import { Info } from '@mui/icons-material';

import NoteChangeRequestDialog from '../NoteChangeRequestDialog';
import NoteDialog from '../NoteDialog';
import NoteDisputeDialog from '../NoteDisputeDialog';
import CategoryChip from '../../UI/CategoryChip'
import { CLOSE_MERCHANT_SUBSCRIPTION_DIALOG } from 'store/actions/actionTypes';
import useClasses from '../../../helpers/useClasses';


const styles = theme => ({
  root: {},
  content: {
    padding: 0
  },
  nameContainer: {
    display: 'flex',
    alignItems: 'center'
  },
  avatar: {
    marginRight: theme.spacing(2)
  },
  actions: {
    justifyContent: 'flex-end'
  },
  note_date: {
    fontWeight: 'bold',
    fontSize: '1.25em'
  },
  note_creator: {
    fontWeight: 'bold',
    fontSize: '1.25em'
  },
  note_copy: {
    paddingTop: '10px'
  },
  tableRowHighlighted: {
    backgroundColor: 'yellow'
  }
});

const NotesTable = props => {
  const {
    notes,
    onArchiveClick,
    merchant_id,
    onSubmitNoteClick,
    onCancelNoteClick,
    onSubmitNoteDisputeClick,
    onCancelNoteDisputeClick,
    onSubmitNoteChangeRequestClick,
    onCancelNoteChangeRequestClick,
    modalOpen,
    disputeModalOpen,
    changeRequestModalOpen,
    onOpenNoteModal,
    onOpenNoteChangeRequestModal,
    current_user,
    accounts,
    is_dm_admin,
    loading_accounts,
    onOpenNoteDisputeModal,
    highlight,
    plan_level,
    saving
  } = props;

  const classes = useClasses(styles);

  const [note, setNote] = useState({
    id: null,
    merchant_id: merchant_id,
    category: '',
    note: '',
    submission_source: '',
    broker_name: ''
  })

  const [noteMode, setNoteMode] = useState('add')

  // const locked_merchants = ['1a795f9b-b3bb-4283-8ad7-820d4fdfc48f']
  const locked_merchants = []
  
  const handleAddNoteClick = () => {
    setNote({
      id: null,
      merchant_id: merchant_id,
      category: '',
      note: '',
      submission_source: '',
      broker_name: ''
    })
    setNoteMode('add')
    onOpenNoteModal()
  }

  const handleEditNoteClick = (event, note) => {
    setNote({
      id: note.resource_id,
      merchant_id: merchant_id,
      category: note.category,
      note: note.note,
      submission_source: note.submission_source,
      broker_name: note.broker_name
    })
    setNoteMode('edit')
    if (note.category === 'Default Account' && !is_dm_admin) {
      onOpenNoteChangeRequestModal()
    } else {
      onOpenNoteModal()
    }
  }

  const handleDeleteNoteClick = (event, note) => {
    setNote({
      id: note.resource_id,
      merchant_id: merchant_id,
      category: note.category,
      note: note.note,
      submission_source: note.submission_source,
      broker_name: note.broker_name
    })
    setNoteMode('dispute')
    onOpenNoteDisputeModal()
  }
  console.log('highlight', highlight)

  return (
    <React.Fragment>
      <CardContent className={classes.content}>
        <PerfectScrollbar>
          <div className={classes.inner}>
            <Table>
              <TableHead sx={{
                backgroundColor: "#fafafa"
              }}>
                <TableRow>
                  <TableCell colSpan={12} align={'right'}>
                    {(locked_merchants.includes(merchant_id) && is_dm_admin) || !locked_merchants.includes(merchant_id) ? 
                    <Button
                      variant="contained"
                      color="primary"
                      className={classes.button}
                      startIcon={<AddIcon />}
                      onClick={handleAddNoteClick}
                    >
                      Add Note
                    </Button>
                    : null}
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {notes.map(note => (
                  // (note.category !== 'Merchant Dispute' || (note.category === 'Merchant Dispute' && is_dm_admin)) ? 
                  (note.category !== 'Merchant Dispute' || (note.category === 'Merchant Dispute')) ? 
                    <TableRow
                      className={highlight && highlight === note.resource_id ? classes.tableRowHighlighted : classes.tableRow}
                      hover
                      key={note.id}
                    >
                      <TableCell colSpan={2}>
                        <CategoryChip category={note.category} />
                      </TableCell>
                      <TableCell colSpan={8}>
                        Added on &nbsp;&nbsp;&nbsp;
                        <span
                          className={classes.note_date}
                        >
                          {moment(note.created_at).format('MM/DD/YYYY')}
                        </span>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;by&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        {is_dm_admin || (note.added_by_account_id == current_user.account_id && current_user.is_admin) ?
                          <span
                            className={classes.note_creator}
                          >
                            {note.added_by} - {note.added_by_user}
                            <Tooltip title="Only admin users for your company can see who entered this record.  This is not displayed to any other DataMerch user.">
                              <IconButton>
                                <Info />
                              </IconButton>
                            </Tooltip>
                          </span>
                          : <span
                              className={classes.note_creator}
                            >
                              {note.added_by}
                            </span>
                        }
                        { (note.submission_source === 'broker' && note.broker_name && (plan_level === 'PRO')) ?
                          <p className={classes.note_copy}>
                            <Chip
                              size="small"
                              label={'File Submitted By:  '+ note.broker_name}
                              variant="outlined"
                            />
                          </p>
                        :
                        (note.submission_source === 'in-house' && (plan_level === 'PRO')) ?
                          <p className={classes.note_copy}>
                            <Chip
                              size="small"
                              label={'File Submitted By:  in-house/retail'}
                              variant="outlined"
                            />
                          </p>
                        :
                          null
                        }
                        { (plan_level !== 'PRO') ?
                          <p className={classes.note_copy}>
                            <Chip
                              size="small"
                              label={'File Submitted By: Available to PRO members only'}
                              variant="outlined"
                            />
                          </p>
                        :
                          null
                        }
                        <p className={classes.note_copy}>{note.note}</p>                 
                      </TableCell>
                      <TableCell colSpan={2} align='right'>
                        { ((locked_merchants.includes(merchant_id) && is_dm_admin) || !locked_merchants.includes(merchant_id)) && (note.created_by_id === current_user.id || current_user.is_dm_admin) ? 
                          <React.Fragment>
                            <IconButton aria-label="edit" onClick={event => handleEditNoteClick(event, note)}>
                              <EditIcon />
                            </IconButton>
                          </React.Fragment>
                        : null }
                        { ((locked_merchants.includes(merchant_id) && is_dm_admin) || !locked_merchants.includes(merchant_id)) && (current_user.is_dm_admin) ? 
                          <React.Fragment>
                            <IconButton aria-label="delete" onClick={event => onArchiveClick(event, note.resource_id)}>
                              <DeleteIcon />
                            </IconButton>
                          </React.Fragment>
                        : null }
                        { ((locked_merchants.includes(merchant_id) && is_dm_admin) || !locked_merchants.includes(merchant_id)) && (!current_user.is_dm_admin && (current_user.account_id === note.added_by_account_id)) ? 
                          <React.Fragment>
                            <IconButton aria-label="delete" onClick={event => handleDeleteNoteClick(event, note)}>
                              <DeleteIcon />
                            </IconButton>
                          </React.Fragment>
                        : null }
                      </TableCell>
                    </TableRow>
                  : null
                ))}
              </TableBody>
            </Table>
          </div>
        </PerfectScrollbar>
      </CardContent>
      <NoteDialog
        open={modalOpen}
        mode={noteMode}
        is_dm_admin={is_dm_admin}
        accounts={accounts}
        loading={loading_accounts}
        onSubmitClick={onSubmitNoteClick}
        onCancelClick={onCancelNoteClick}
        merchantNote={note}
        plan_level={plan_level}
        saving={saving}
      />
      <NoteDisputeDialog
        open={disputeModalOpen}
        mode={noteMode}
        is_dm_admin={is_dm_admin}
        loading={loading_accounts}
        onSubmitClick={onSubmitNoteDisputeClick}
        onCancelClick={onCancelNoteDisputeClick}
        merchantNote={note}
      />
      <NoteChangeRequestDialog
        open={changeRequestModalOpen}
        onSubmitClick={onSubmitNoteChangeRequestClick}
        onCancelClick={onCancelNoteChangeRequestClick}
        merchantNote={note}
      />
    </React.Fragment>
  );
};

const mapStateToProps = state => {
  return {
    modalOpen: state.note.modalOpen,
    disputeModalOpen: state.note.disputeModalOpen,
    changeRequestModalOpen: state.note.changeRequestModalOpen,
    current_user: state.auth.user,
    is_dm_admin: state.auth.user.is_dm_admin,
    plan_level: state.auth.user.plan_level
  }
}

const mapDispatchToProps = dispatch => {
  return {
    onOpenNoteModal: () => dispatch(actions.openNoteModal()),
    onOpenNoteDisputeModal: () => dispatch(actions.openNoteDisputeModal()),
    onOpenNoteChangeRequestModal: () => dispatch(actions.openNoteChangeRequestModal())
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(NotesTable)
